import { CreateManufacturerBody, Manufacturer, UpdateManufacturerBody } from '@core/models/manufacturer.model';
import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class ManufacturerService {
    private readonly getManufacturersURL = `/manufacturers/get_manufacturers`;
    private readonly getManufacturerByIdURL = `/manufacturers/get_manufacturer`;
    private readonly createManufacturerURL = `/manufacturers/create_manufacturer`;
    private readonly updateManufacturerURL = `/manufacturers/update_manufacturer`;
    private readonly deleteManufacturerURL = `/manufacturers/delete_manufacturer`;

    // ---------------------------------------------------------------

    getManufacturers() {
        return fetchWithRetry(API.get<Manufacturer[]>(this.getManufacturersURL));
    }

    getManufacturerById(id: number) {
        return fetchWithRetry(API.get<Manufacturer>(`${this.getManufacturerByIdURL}/${id}`));
    }

    createManufacturer(body: CreateManufacturerBody) {
        return fetchWithRetry(API.post(this.createManufacturerURL, body));
    }

    updateManufacturer(body: UpdateManufacturerBody) {
        return fetchWithRetry(API.put(this.updateManufacturerURL, body));
    }

    deleteManufacturer(id: number) {
        return fetchWithRetry(API.delete(`${this.deleteManufacturerURL}/${id}`));
    }
}

export default new ManufacturerService();

